import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { Create_Api_formdata, Get_Api } from '../ApiUrls';
import Select from "react-select";
import { toast } from 'react-toastify';
import WhatsAppButton from '../Components/WhatsAppButton';

function AddProperty() {
    const [IsUploading, setIsUploading] = useState(false);
    const [Name, setName] = useState('');
    const [Price, setPrice] = useState('');
    const [Address, setAddress] = useState('');
    const [PinCode, setPinCode] = useState('');
    const [Lat, setLat] = useState('');
    const [Long, setLong] = useState('');
    const [Room, setRoom] = useState('');
    const [Bath, setBath] = useState('');
    const [SquareFeet, setSquareFeet] = useState('');
    const [Floor, setFloor] = useState('');
    const [Entrance, setEntrance] = useState('');
    const [BuildIn, setBuildIn] = useState('');
    const [PerSquarePrice, setPerSquarePrice] = useState('');
    const [Parking, setParking] = useState('');
    const [Amenities, setAmenities] = useState([]);
    const [Amenitiesids, setAmenitiesids] = useState([]);
    const [Category, setCategory] = useState('');
    const [Location, setLocation] = useState('');
    const [ProPertyDescription, setProPertyDescription] = useState('');
    const [Youtubelink, setYoutubelink] = useState('');
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [selectedImages, setSelectedImages] = useState([null, null, null, null, null]);
    const [Brochure, setBrochure] = useState(null);
    const [Gallary, setGallary] = useState([null, null, null, null, null]);

    const [UserName, setUserName] = useState('');
    const [Email, setEmail] = useState('');
    const [Mobile, setMobile] = useState('');

    const handleBrochureChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "application/pdf") {
            setBrochure(file);
        } else {
            alert("Please select a valid PDF file.");
        }
    };

    const [AllCategory, setAllCategory] = useState([]);
    const [AllAmenities, setAllAmenities] = useState([]);

    const [All_Locations, setAll_Locations] = useState([]);
    const Get_All_Locations = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllNewLocation');
            setAll_Locations(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Locations();
    }, []);



    const Get_All_Categorys = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllCategorys');
            setAllCategory(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const Get_All_Amenitiess = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllAmenities');
            setAllAmenities(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    useEffect(() => {
        Get_All_Amenitiess()
        Get_All_Categorys();
    }, []);


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleImageChange1 = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const newImages = [...selectedImages];
            newImages[index] = file;
            setSelectedImages(newImages);
        }
    };
    const handleImageChange2 = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            const newImages = [...Gallary];
            newImages[index] = file;
            setGallary(newImages);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!Name.trim()) return toast.error('Name is required!');
        if (!Price || isNaN(Price) || Price <= 0) return toast.error('Valid Price is required!');
        if (!Address.trim()) return toast.error('Address is required!');
        if (!PinCode || isNaN(PinCode) || PinCode.length !== 6) return toast.error('Valid PinCode is required!');
        if (!Lat || isNaN(Lat)) return toast.error('Valid Latitude is required!');
        if (!Long || isNaN(Long)) return toast.error('Valid Longitude is required!');
        if (!Room || isNaN(Room) || Room <= 0) return toast.error('Number of Rooms is required!');
        if (!Bath || isNaN(Bath) || Bath <= 0) return toast.error('Number of Bathrooms is required!');
        if (!SquareFeet || isNaN(SquareFeet) || SquareFeet <= 0) return toast.error('Valid SquareFeet value is required!');
        if (!Floor || isNaN(Floor) || Floor <= 0) return toast.error('Floor number is required!');
        if (!Entrance.trim()) return toast.error('Entrance is required!');
        if (!BuildIn.trim()) return toast.error('Build-in year is required!');
        // if (!PerSquarePrice || isNaN(PerSquarePrice) || PerSquarePrice <= 0) return toast.error('Valid Price per SquareFoot is required!');
        if (!Parking.trim()) return toast.error('Parking information is required!');
        if (!ProPertyDescription.trim()) return toast.error('Property Description is required!');
        if (!Array.isArray(Amenities) || Amenities.length === 0) return toast.error('Select at least one Amenity!');
        if (!Array.isArray(Amenitiesids) || Amenitiesids.length === 0) return toast.error('Select at least one Amenity!');
        if (!Category.trim()) return toast.error('Category is required!');
        if (!Location.trim()) return toast.error('Location is required!');
        if (!image) return toast.error('Property Image is required!');
        if (!Brochure) return toast.error('Property Brochure is required!');

        setIsUploading(true);
        
        const formData = new FormData();
        formData.append('UserName', UserName);
        formData.append('Email', Email);
        formData.append('Mobile', Mobile);
        formData.append('Name', Name);
        formData.append('Price', Price);
        formData.append('Address', Address);
        formData.append('PinCode', PinCode);
        formData.append('Lat', Lat);
        formData.append('Long', Long);
        formData.append('Room', Room);
        formData.append('Bath', Bath);
        formData.append('SquareFeet', SquareFeet);
        formData.append('Floor', Floor);
        formData.append('Entrance', Entrance);
        formData.append('BuildIn', BuildIn);
        formData.append('Parking', Parking);
        formData.append('ProPertyDescription', ProPertyDescription);
        formData.append('Amenities', Amenitiesids);
        formData.append('Category', Category);
        formData.append('Location', Location);
        formData.append('Image', image);
        formData.append('Youtubelink', Youtubelink);
        formData.append('Brochure', Brochure);
        selectedImages.forEach((image, index) => {
            if (image) {
                formData.append('AllImages', image);
            }
        });
        Gallary.forEach((image, index) => {
            if (image) {
                formData.append('Gallary', image);
            }
        });

        try {
            const response = await Create_Api_formdata('api/admin/UserCreateProperty', formData);
            alert(response?.message);
            setIsUploading(false);
            setName('');
            setPrice('');
            setAddress('');
            setPinCode('');
            setLat('');
            setLong('');
            setRoom('');
            setBath('');
            setSquareFeet('');
            setFloor('');
            setEntrance('');
            setBuildIn('');
            setPerSquarePrice('');
            setParking('');
            setProPertyDescription('');
            setAmenities([]);
            setAmenitiesids([]);
            setCategory('');
            setYoutubelink('');
            setImage(null);
            setPreview(null);
            setBrochure(null);
            setSelectedImages([null, null, null, null, null])
            setGallary([null, null, null, null, null])
            setUserName('')
            setEmail('');
            setMobile('');
            console.log('Property created successfully:', response);
        } catch (error) {
            alert(error?.response?.data?.message);
            setIsUploading(false);
            console.error('Error creating Property:', error);
        }
    };

    const handleChange = (selectedOptions) => {
        const ids = selectedOptions.map(option => option.value);
        setAmenities(selectedOptions);
        setAmenitiesids(ids)
    };



    return (
        <>
            <Navbar />
            <div className="Properties-header">
                <h1>Add Property</h1>
                <p>
                    Home / <span className="active">Add Property</span>
                </p>
            </div>
            <br />
            <div>
                <div className="property-form-container">
                    <br />
                    <h2>PROPERTY INFORMATION</h2>
                    <div className="form-grid">
                        <input type="text"
                            placeholder="Name*"
                            value={Name}
                            onChange={(e) => { setName(e.target.value) }}
                        />
                        <input type="text"
                            placeholder="Price*"
                            value={Price}
                            onChange={(e) => { setPrice(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Address*"
                            value={Address}
                            onChange={(e) => { setAddress(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="PinCode"
                            value={PinCode}
                            onChange={(e) => { setPinCode(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Latitude"
                            value={Lat}
                            onChange={(e) => { setLat(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Longitute"
                            value={Long}
                            onChange={(e) => { setLong(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Room"
                            value={Room}
                            onChange={(e) => { setRoom(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Bath"
                            value={Bath}
                            onChange={(e) => { setBath(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Floor"
                            value={Floor}
                            onChange={(e) => { setFloor(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="SquareFeet (Sq.ft)"
                            value={SquareFeet}
                            onChange={(e) => { setSquareFeet(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Entrance"
                            value={Entrance}
                            onChange={(e) => { setEntrance(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Per Square Price (Sq.ft)"
                            value={PerSquarePrice}
                            onChange={(e) => { setPerSquarePrice(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Parking"
                            value={Parking}
                            onChange={(e) => { setParking(e.target.value) }}
                        />
                        <select
                            value={BuildIn}
                            onChange={(e) => { setBuildIn(e.target.value) }}>
                            <option value='' disabled hidden> Build In</option>
                            <option value='2025' >2025</option>
                            <option value='2020' >2020</option>
                            <option value='2015' >2015</option>
                            <option value='2010' >2010</option>
                            <option value='2010' >2010</option>
                        </select>
                        <select
                            value={Category}
                            onChange={(e) => { setCategory(e.target.value) }}
                        >
                            <option value='' disabled hidden>Select Property Type*</option>
                            {AllCategory?.map((category, index) => (
                                <option key={index} value={category?._id}>
                                    {category?.Name}
                                </option>
                            ))}
                        </select>
                        <select
                            value={Location}
                            onChange={(e) => { setLocation(e.target.value) }}
                        >
                            <option value='' disabled hidden>Select Location*</option>
                            {All_Locations?.map((location, index) => (
                                <option key={index} value={location?._id}>
                                    {location?.Location}
                                </option>
                            ))}
                        </select>
                    </div>
                    <br />
                    <h2> Select Amenities </h2>
                    <br />
                    <Select
                        options={AllAmenities.map(amenity => ({ value: amenity._id, label: amenity.Name }))}
                        isMulti
                        value={Amenities}
                        onChange={handleChange}
                        placeholder="Select Amenities"
                    />
                    <br />
                    <br />
                    <h2> Property Description </h2>
                    <br />
                    <input
                        type="text"
                        placeholder="Property Description"
                        value={ProPertyDescription}
                        onChange={(e) => { setProPertyDescription(e.target.value) }}
                    />
                    <br />
                    <br />
                    <h2> Youtubelink </h2>
                    <br />
                    <input
                        type="text"
                        placeholder="Youtubelink"
                        value={Youtubelink}
                        onChange={(e) => { setYoutubelink(e.target.value) }}
                    />
                    <br />
                    <br />
                    <br />
                    <br />
                    <h2> User Info </h2>
                    <br />
                    <div className="form-grid">
                        <input
                            type="text"
                            placeholder="UserName"
                            value={UserName}
                            onChange={(e) => { setUserName(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Email"
                            value={Email}
                            onChange={(e) => { setEmail(e.target.value) }}
                        />
                        <input
                            type="text"
                            placeholder="Mobile"
                            value={Mobile}
                            onChange={(e) => { setMobile(e.target.value) }}
                        />
                    </div>
                    <br />
                    <br />
                    <h2>LOCATION INFORMATION</h2>
                    <br />
                    <div className="form-grid">
                        <div style={{ width: '100%' }}>
                            <label htmlFor="image-upload" style={{ display: 'block', marginBottom: '5px' }}>Front Image</label>
                            <div
                                style={{
                                    width: '100px',
                                    height: '150px',
                                    border: '2px dashed #ccc',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    boxShadow: '0px 0px 7px 0px #89898933',
                                }}
                            >
                                <input
                                    id="image-upload"
                                    type="file"
                                    accept="image/*"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        opacity: 0,
                                        cursor: 'pointer',
                                    }}
                                    onChange={handleImageChange}
                                />
                                {preview ? (
                                    <img
                                        src={preview}
                                        alt="Preview"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                ) : (
                                    <p
                                        style={{
                                            color: '#888',
                                            fontSize: '14px',
                                            textAlign: 'center',
                                        }}
                                        onClick={handleImageChange}
                                    >
                                        Click to select
                                    </p>
                                )}
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: "20px", alignItems: "center", width: "100%" }}>

                            {/* Upload PDF Brochure */}
                            <div style={{ flex: 1 }}>
                                <label style={{ display: "block", marginBottom: "5px" }}>Upload PDF Brochure</label>
                                <div
                                    style={{
                                        width: "50%",
                                        height: "200px",
                                        border: "2px dashed #ccc",
                                        borderRadius: "8px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        position: "relative",
                                        cursor: "pointer",
                                        textAlign: "center",
                                    }}
                                >
                                    <input
                                        type="file"
                                        accept="application/pdf"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            opacity: 0,
                                            cursor: "pointer",
                                        }}
                                        onChange={handleBrochureChange}
                                    />
                                    {Brochure ? (
                                        <p style={{ color: "#1976d2" }}>{Brochure?.name}</p>
                                    ) : (
                                        <p style={{ color: "#888" }}>Click to select a PDF</p>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                    <h2>Images</h2>
                    <br />
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '10px',
                                padding: '20px',
                                flexWrap: 'wrap',
                            }}
                        >
                            {selectedImages?.map((image, index) => (
                                <div
                                    key={index}
                                    style={{
                                        width: '100px',
                                        height: '150px',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        boxShadow: '0px 0px 7px 0px #89898933',
                                    }}
                                >
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="input"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            opacity: 0,
                                            cursor: 'pointer',
                                        }}
                                        onChange={(e) => handleImageChange1(e, index)}
                                    />
                                    {image ? (
                                        <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Preview ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    ) : (
                                        <p
                                            style={{
                                                color: '#888',
                                                fontSize: '14px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Click to select
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <br />
                    <div>
                        <label id="amenities-label" style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                            Gallary
                        </label>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '10px',
                                padding: '20px',
                                flexWrap: 'wrap',
                            }}
                        >
                            {Gallary?.map((image, index) => (
                                <div
                                    key={index}
                                    style={{
                                        width: '100px',
                                        height: '150px',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        boxShadow: '0px 0px 7px 0px #89898933',
                                    }}
                                >
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="input"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            opacity: 0,
                                            cursor: 'pointer',
                                        }}
                                        onChange={(e) => handleImageChange2(e, index)}
                                    />
                                    {image ? (
                                        <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Preview ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    ) : (
                                        <p
                                            style={{
                                                color: '#888',
                                                fontSize: '14px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Click to select
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <button
                        className={`submit-button ${IsUploading ? "opacity-50 cursor-not-allowed" : ""}`}
                        onClick={(e) => handleSubmit(e)}
                        disabled={IsUploading}
                    >
                        {IsUploading ? "Please Wait..." : "Add Property"}
                    </button>

                </div>
            </div>
            <WhatsAppButton />
            <Footer />
        </>
    )
}

export default AddProperty